import {
  fetchQueue
} from '../../utils/api'

function fetchPrimaryBg() {
  let f = fetchQueue('primaryBg')
  return f && /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(f[0]) ? f[0] : null
}

function fetchPosition() {
  let f = fetchQueue('startUpPosition')
  return f && ['bottom-right', 'bottom-left', 'top-left', 'top-right'].indexOf(f[0]) ? f[0] : null
}

export default {
  //
  //Widget Theme
  //
  getPrimaryBg(state) {
    let bg = fetchPrimaryBg()
    return bg ? bg : state.widget && state.widget.theme ? state.widget.theme.primary_bg : ''
  },
  getAvatarBg(state) {
    return state.widget && state.widget.theme ? state.widget.theme.avatar_bg : ''
  },
  hideBrand(state) {
    return state.widget && state.widget.theme && state.widget.theme.hide_brand == 'none' ? true : false
  },
  isLightDark(state) {

    let bg = fetchPrimaryBg()
    bg || (bg = state.widget && state.widget.theme ? state.widget.theme.primary_bg : '')

    if (!bg) return ''

    const hexcolor = bg.substr(1)
    const r = parseInt(hexcolor.substr(0, 2), 16);
    const g = parseInt(hexcolor.substr(2, 2), 16);
    const b = parseInt(hexcolor.substr(4, 2), 16);
    const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
    return (yiq >= 190) ? 'light' : 'dark';
  },
  getDefaultImg(state) {
    const img = state.widget && state.widget.theme ? state.widget.theme.default_img : ''
    if (!img)
      return ''
    if (typeof img == 'number')
      return '//@@CDN/assets/img/sc-header-icon-default-' + img + '.png'
    if (typeof img == 'string')
      return img
  },
  getStartUpMode(state) {
    let f = fetchQueue('startUpMode')
    let o = f && ['bubblehead', 'minimize', 'link'].indexOf(f[0]) >= 0 ? f[0] : null
    return o ? o : state.widget && state.widget.theme ? state.widget.theme.startup_mode : 'link'
  },
  getPosition(state) {
    let p = fetchPosition()
    return p ? p : state.widget && state.widget.theme ? state.widget.theme.position : ''
  },
  allowPopOut(state) {
    //two conditions canWriteStorage & allowed by widget setttings
    return !state.isSafari && state.widget && state.widget.theme && state.widget.theme.popout === 'block'
  },
}
